export function ConsentText() {
    return (
        <p className="text-muted-foreground text-sm">
            By creating an account, you agree to our{' '}
            <a
                href="https://www.nessoapp.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4"
            >
                Terms
            </a>
            ,{' '}
            <a
                href="https://www.nessoapp.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4"
            >
                Privacy Policy
            </a>
            , and{' '}
            <a
                href="https://www.nessoapp.com/baa"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4"
            >
                BAA
            </a>
        </p>
    );
}
